/*
 * Collection ordering by availability.
 *
 * Shopify paginates a collection using its sort order, which ignores stock, so a theme
 * can only reorder the products already dealt onto the current page. The availability
 * filter, by contrast, is applied before pagination. So the collection is browsed as two
 * ordered segments -- in stock, then sold out -- and this script joins them:
 *
 *   1. a collection URL carrying no availability filter defaults to the in-stock segment
 *   2. "next" on the last in-stock page continues into the sold-out segment, and
 *      "previous" on its first page comes back
 *
 * Segment membership is Shopify's live availability data, so a product that comes back
 * into stock moves into the in-stock pages on its next request with nothing to maintain.
 */
(function () {
  var PARAM = 'filter.v.availability';
  var SHOW_ALL_KEY = 'tcp:show-all-stock:';

  function isCollectionGrid() {
    // /collections/<handle>, but not /collections itself nor a product under one
    var p = window.location.pathname;
    return /^\/collections\/[^\/]+\/?$/.test(p);
  }

  function showAllFlag() {
    try {
      return window.sessionStorage.getItem(SHOW_ALL_KEY + window.location.pathname) === '1';
    } catch (e) {
      return false;
    }
  }

  function setShowAllFlag() {
    try {
      window.sessionStorage.setItem(SHOW_ALL_KEY + window.location.pathname, '1');
    } catch (e) {
      /* private mode -- the default simply reapplies on the next load */
    }
  }

  /* 1. Default a bare collection URL to the in-stock segment. ------------------ */
  function applyDefault() {
    if (!isCollectionGrid() || showAllFlag()) return;

    var url = new URL(window.location.href);
    var hasAnyFilter = false;
    url.searchParams.forEach(function (_, key) {
      if (key.indexOf('filter.') === 0) hasAnyFilter = true;
    });
    if (hasAnyFilter) return; // the shopper's own filtering wins

    url.searchParams.append(PARAM, '1');
    url.searchParams.delete('page'); // page numbers differ once filtered
    window.location.replace(url.pathname + url.search + url.hash);
  }

  /* 2. Join the two segments across the pagination arrows. --------------------- */
  function segmentUrl(availability, page) {
    var url = new URL(window.location.href);
    url.searchParams.delete(PARAM);
    url.searchParams.append(PARAM, availability);
    if (page && page > 1) {
      url.searchParams.set('page', page);
    } else {
      url.searchParams.delete('page');
    }
    return url.pathname + url.search;
  }

  function wireBridges() {
    var nav = document.querySelector('[data-stock-order]');
    if (!nav) return;

    // Rebuild each bridge href from the live URL so other active filters survive the hop.
    var toSoldOut = nav.querySelector('[data-stock-bridge="to-sold-out"]');
    if (toSoldOut) toSoldOut.setAttribute('href', segmentUrl('0', 1));

    var toInStock = nav.querySelector('[data-stock-bridge="to-in-stock"]');
    if (toInStock) {
      var page = parseInt(toInStock.getAttribute('data-bridge-page'), 10) || 1;
      toInStock.setAttribute('href', segmentUrl('1', page));
    }
  }

  /* Remember an explicit "show everything" so the default stops fighting the shopper. */
  function watchAvailabilityFacet() {
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.name || input.name !== PARAM) return;
      if (!input.checked) setShowAllFlag();
    });
  }

  applyDefault();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      wireBridges();
      watchAvailabilityFacet();
    });
  } else {
    wireBridges();
    watchAvailabilityFacet();
  }

  // Dawn swaps the grid (and its pagination) in place when filters or sort change.
  var observer = new MutationObserver(function () {
    wireBridges();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
